// extracted by mini-css-extract-plugin
module.exports = {"quoteBtn":"NewQuote_quoteBtn__2tWVc"};